//const api_url = process.env.REACT_APP_API_URL + "ventas?fechaDesde={fechaDesde}&fechaHasta={fechaHasta}&estado={F|T}";
import axios from "axios";
import { responseError } from "./UtilService";
const api_url = process.env.REACT_APP_API_URL + "/ventas"


export async function getVentas(fechaDesde = '', fechaHasta = '', incluyePendientes = false) {
    let params = "";
    if (fechaDesde) {
        params += "?fechaDesde="+fechaDesde;
    }
    if (fechaHasta) {
        params += "&fechaHasta="+fechaHasta;
    }
    if (!incluyePendientes) {
        params += "&estado=F";
    }
    try {
        let resp = await axios.get(api_url+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err, "Hubo un error al obtener datos de ventas desde el servidor.");
    }
    
}